import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import LockIcon from "@mui/icons-material/Lock";
import { createCheckoutSession } from "../../services/subscription";
import "./SubscriptionModal.css";

export const SubscriptionModal = ({ show, onHide }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleBuyNow = async () => {
    setLoading(true);
    setError("");

    try {
      const response = await createCheckoutSession();

      if (response?.checkout_url) {
        window.open(response.checkout_url, "_blank");
      } else {
        setError("Unable to create checkout session. Please try again.");
      }
    } catch (err) {
      console.error("Error creating checkout session:", err);
      setError("An error occurred. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setError("");
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop="static"
      keyboard={false}
      centered
      className="subscription-modal"
      size="md"
    >
      <Modal.Header>
        <div style={{ width: "100%", textAlign: "center" }}>
          <div className="subscription-lock-icon">
            <LockIcon />
          </div>
          <h4 className="subscription-title">Subscription Required</h4>
        </div>
      </Modal.Header>
      <Modal.Body>
        <p className="subscription-message">
          To save and create coupons, you need an active subscription.
          Get unlimited access to all coupon creation features.
        </p>
        <div className="subscription-price-box">
          <span className="subscription-price">$65</span>
          <span className="subscription-price-period">one-time</span>
        </div>
        {error && <div className="subscription-error">{error}</div>}
      </Modal.Body>
      <Modal.Footer>
        <div className="subscription-btn-container">
          <Button
            variant="outlined"
            className="subscription-btn-cancel"
            onClick={handleCancel}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            className="subscription-btn-buy"
            onClick={handleBuyNow}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Buy Now"
            )}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
